import styled from 'styled-components'
import { SIZES } from '../../../constants'

export default styled.img`
  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    width: 160px;
  }
  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    width: 100%;
    height: auto;
  }
`
